import { createRouter, createWebHistory } from 'vue-router'
import routes from './routes'
import { useUserStore } from '@stores/users'

export const router = createRouter({
  history: createWebHistory(),
  scrollBehavior: (to, from) => {
    if (to.path !== from.path) {
      return {
        left: 0,
        top: 0
      }
    }
  },
  linkExactActiveClass: 'active',
  routes,
})

router.beforeEach((to) => {
  const userStore = useUserStore()

  // Set document title
  document.title = to.meta.title ? `${to.meta.title} – Relevize` : 'Relevize'

  if (userStore?.isAdmin) return true // Always pass admins through
})
